/* Three real native variants enter the cart. Only Shopify applies charged discounts. */
(() => {
  if (!customElements.get('ona-promo-banner')) customElements.define('ona-promo-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      const key = 'ona-promo-dismissed-b2g1-stack-v2';
      const measure = () => {
        // Bars below pin under the sale bar, so they need its live height.
        const height = this.hidden ? 0 : Math.round(this.getBoundingClientRect().height);
        document.documentElement.style.setProperty('--ona-promo-h', `${height}px`);
      };
      const sync = () => {try {if (sessionStorage.getItem(key) === '1') this.hidden = true;} catch (_) { /* Dismissal still works if storage is unavailable. */ } measure();};
      sync();
      this.resize = new ResizeObserver(measure); this.resize.observe(this);
      const close = this.querySelector('.ona-promo-bar__close');
      if (close) {
        close.hidden = false;
        close.addEventListener('click', () => {
          this.hidden = true;
          measure();
          try {sessionStorage.setItem(key, '1');} catch (_) {}
          this.nextElementSibling?.querySelector('.ccn-wordmark')?.focus({preventScroll:true});
        }, {signal});
      }
      window.addEventListener('pageshow', sync, {signal});
    }
    disconnectedCallback() {this.resize?.disconnect();document.documentElement.style.removeProperty('--ona-promo-h');this.controller?.abort();this.controller=null;}
  });
  if (!customElements.get('ona-promo-builder')) customElements.define('ona-promo-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.catalog = JSON.parse(this.querySelector('[data-promo-catalog]').textContent);
      this.slots = [...this.querySelectorAll('[data-promo-slot]')];
      this.button = this.querySelector('[data-set-add]');
      this.error = this.querySelector('[data-set-error]');
      this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(value/100);
      this.slots.forEach(slot => {
        const style = slot.querySelector('[data-style]');
        this.catalog.filter(p => p.variants.some(v => v.available)).forEach(p => style.add(new Option(p.title, p.handle)));
        style.addEventListener('change', () => this.colors(slot), {signal});
        slot.querySelector('[data-color]').addEventListener('change', () => this.sizes(slot), {signal});
        slot.querySelector('[data-size]').addEventListener('change', () => this.update(), {signal});
      });
      this.querySelector('form').addEventListener('submit', event => {event.preventDefault();this.add();}, {signal});
      window.addEventListener('pageshow', event => {if(event.persisted){this.pending=false;this.button.textContent='Add all three to bag';this.update();}}, {signal});
      this.update();
    }
    product(slot) {return this.catalog.find(p => p.handle === slot.querySelector('[data-style]').value);}
    reset(select,label) {select.replaceChildren(new Option(label,''));select.disabled=true;}
    colors(slot) {
      const p=this.product(slot), color=slot.querySelector('[data-color]');
      this.reset(color,'Choose a color'); this.reset(slot.querySelector('[data-size]'),'Choose a size');
      if(p){[...new Set(p.variants.filter(v=>v.available).map(v=>v.option1))].forEach(c=>color.add(new Option(c,c)));color.disabled=false;}
      this.update();
    }
    sizes(slot) {
      const p=this.product(slot), color=slot.querySelector('[data-color]').value, size=slot.querySelector('[data-size]');
      this.reset(size,'Choose a size');
      if(p && color){p.variants.filter(v=>v.available && v.option1===color).forEach(v=>size.add(new Option(v.option2,String(v.id))));size.disabled=false;}
      this.update();
    }
    selections() {return this.slots.map(slot=>{const p=this.product(slot);return {product:p,variant:p?.variants.find(v=>String(v.id)===slot.querySelector('[data-size]').value && v.available)};});}
    update() {
      const choices=this.selections();
      choices.forEach((c,i)=>{this.slots[i].querySelector('[data-slot-price]').textContent=c.variant ? `${this.money(c.variant.price)} · ${c.product.pack===2?'2 panels':'1 panel'}` : 'Choose your curtain';});
      const ready=choices.every(c=>c.variant);
      this.button.disabled=!ready || Boolean(this.pending);
      this.setAttribute('aria-busy',String(Boolean(this.pending)));
      if(ready){const prices=choices.map(c=>c.variant.price).sort((a,b)=>a-b);const total=prices[1]+prices[2], savings=prices[0], panels=choices.reduce((n,c)=>n+c.product.pack,0);this.querySelector('[data-set-summary]').textContent=`3 items · ${panels} panels · Set subtotal ${this.money(total)} · Save ${this.money(savings)}. Final bag totals confirmed before payment.`;}
      else this.querySelector('[data-set-summary]').textContent=`${choices.filter(c=>c.variant).length} of 3 selected. Choose all three items to see your saving.`;
    }
    async add() {
      if(this.pending || !this.querySelector('form').reportValidity())return;
      const choices=this.selections();if(!choices.every(c=>c.variant))return;
      this.pending=true;this.error.textContent='';this.button.textContent='Adding…';this.update();
      try {
        const response=await fetch(this.dataset.addUrl || '/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:choices.map(c=>({id:c.variant.id,quantity:1}))})});
        const result=await response.json();if(!response.ok || result.status)throw new Error(result.description || 'This set could not be added. Review your bag and try again.');
        window.location.assign(this.dataset.cartUrl || '/cart');
      } catch(error) {
        this.error.textContent=error instanceof TypeError ? 'Connection interrupted. Check your bag before trying again to avoid adding this set twice.' : error.message;
        this.pending=false;this.button.textContent='Add all three to bag';this.update();
      }
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  });
  function openBuilder(){if(location.hash==='#ona-set'){const details=document.getElementById('ona-set');if(details)details.open=true;}}
  window.addEventListener('hashchange',openBuilder);openBuilder();
})();

/* Header hides on the way down and comes back on the way up. Near the top it is always shown. */
(() => {
  const root = document.documentElement;
  const SHOW_ABOVE = 90, HIDE_STEP = 8, REVEAL_STEP = 24;
  let last = Math.max(0, window.scrollY), lastHeight = root.scrollHeight, queued = false;
  const apply = () => {
    queued = false;
    const y = Math.max(0, window.scrollY), height = root.scrollHeight;
    // Image-heavy listings grow as they lazy-load, which moves the scroll position without
    // the shopper scrolling. Re-base instead of reading that as a direction change.
    if (height !== lastHeight) { lastHeight = height; last = y; return; }
    if (y < SHOW_ABOVE) { root.dataset.onaNav = 'up'; last = y; return; }
    const delta = y - last;
    if (delta > HIDE_STEP) { root.dataset.onaNav = 'down'; last = y; }
    else if (delta < -REVEAL_STEP) { root.dataset.onaNav = 'up'; last = y; }
  };
  root.dataset.onaNav = 'up';
  window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(apply); } }, { passive: true });
  // A drawer or dialog opening should never leave the header hidden behind it.
  document.addEventListener('click', event => { if (event.target.closest('[data-ccn-open],[data-ccn-search-open],#cart-icon-bubble')) root.dataset.onaNav = 'up'; }, true);
})();
